








































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { PAGINATION_ACTIONS, PAGINATION_DEFAULT_RESULTS_LIMIT } from '~/constants/pagination';
import type { PaginationActions } from '~/constants/pagination';
import { usePagination } from '~/composables/usePagination';
import CustomPaginationButton from '@/components/molecules/Pagination/CustomPaginationButton.vue';
import { createArrayBasedOnStartEndPoint } from '~/helpers/arrays/createArrayBasedOnStartEndPoint';

export default defineComponent({
  name: 'CustomPagination',
  components: {
    CustomPaginationButton,
  },
  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
  },
  setup(props, { emit }) {
    const {
      currentPage,
      totalPages,
      getChangePageParams,
      startPage,
      endPage,
    } = usePagination(props.totalResultsAmount, props.perPage);
    const displayedPages = computed(() => createArrayBasedOnStartEndPoint(startPage.value, endPage.value));

    const onPageChange = (action: PaginationActions, page?: number) => {
      const pageChangeParams = getChangePageParams(action, page);
      emit('onPageChange', pageChangeParams);
    };

    const isFirstPage = computed(() => currentPage.value === 1);

    return {
      getChangePageParams,
      currentPage,
      totalPages,
      displayedPages,
      PAGINATION_ACTIONS,
      onPageChange,
      isFirstPage,
      startPage,
      endPage,
    };
  },
});
